import { createSlice } from "@reduxjs/toolkit";
import toolResultInitialState from "@/components/ToolsResultPage/redux/initialState";
import ToolResultReducer from "@/components/ToolsResultPage/redux/reducers";

const toolsSlice = createSlice({
  name: "tools",
  initialState: toolResultInitialState,
  reducers: ToolResultReducer,
});

export const { setToolResultContentData, setToolType, setToolData, setToolSeo } = toolsSlice.actions;

export default toolsSlice.reducer;
